import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from './route.entity';


export const ROUTE_TRANSLATE_KEYS: Record<string, string> = {
    [RouteEntity.SignIn]: marker('route.signIn'),
    [RouteEntity.Main]: marker('route.main'),
    [RouteEntity.SellProduct]: marker('route.sell-product'),
    [RouteEntity.AddCard]: marker('route.add-card'),
    [RouteEntity.PrintedTicket]: marker('route.printed-ticket'),
    [RouteEntity.TopUp]: marker('route.top-up'),
    [RouteEntity.LogOut]: marker('route.logout'),
};
